module.exports = __webpack_public_path__ + "static/img/online.a1931ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/online.png
// module id = vCSb
// module chunks = 4